<script>
import Page from '../../components/page.vue'
import SearchBar from '../../components/search-bar.vue'
import Pull from '../../components/pull.vue'
import { getCourseList, getConditions } from '../../api/portal'
import styles from '../book-list/item.module.styl'
import { courseDefaultCover } from '../../config/values'

const TYPE = 2
export default {
  components: {
    Page,
    SearchBar,
    Pull
  },
  data () {
    return {
      filterList: [],
      selectedList: [],
      pageNum: 1,
      pageSize: 10,
      keyword: '',
      courseList: [],
      total: 0,
      allLoaded: false,
      ready: false,
      defaultCover: courseDefaultCover,
      styles
    }
  },
  methods: {
    getQuery () {
      const query = {}
      this.selectedList.forEach((it, index) => {
        const name = this.filterList[index].name
        query[name] = it.filter(it => it !== -1).join(',')
      })
      query.keyword = this.keyword
      query.pageSize = this.pageSize
      query.pageNum = this.pageNum
      return query
    },
    async pull (append = false) {
      const { data } = await getCourseList(this.getQuery())
      if (append === true) {
        this.courseList = this.courseList.concat(data.body.list)
      } else {
        this.courseList = data.body.list || []
      }
      this.total = data.body.page.totalCount
      if (this.total <= this.courseList.length) {
        this.allLoaded = true
      }
    },
    async search () {
      this.pageNum = 1
      this.allLoaded = false
      await this.pull()
    },
    async pullUpMethod () {
      this.pageNum++
      await this.pull(true)
    },
    async pullDownMethod () {
      await this.search()
    },
    viewBookDetail (id) {
      this.$router.push({
        name: 'courseDetail',
        params: {
          id
        }
      })
    },
    async getConditions () {
      const res = await getConditions(TYPE)
      this.filterList = res.data.body
      this.selectedList = this.filterList.map(it => {
        return [-1]
      })
    }
  },
  async mounted () {
    await this.getConditions()
    this.ready = true
  }
}
</script>

<template>
  <Page title="课程中心">
    <div :class="$style.container">
      <SearchBar
        :list="filterList"
        :selectedList="selectedList"
        v-model="keyword"
        @search="search"
        @fetch="getConditions"
        :class="$style.searchBar"
      />
      <Pull :allLoaded="allLoaded" :pullDownMethod="pullDownMethod" :pullUpMethod="pullUpMethod" v-if="ready">
        <div :class="$style.list">
          <div
            v-for="(item) in courseList"
            :class="$style.item"
            :key="item.courseID"
            @click="viewBookDetail(item.courseID)"
          >
            <img :src="item.logo || defaultCover" :alt="item.title" />
            <div :class="$style.desc">
              <div :class="$style.name">{{item.title}}</div>
              <div :class="styles.intro">{{item.description}}</div>
            </div>
          </div>
        </div>
      </Pull>
    </div>
  </Page>
</template>

<style lang="stylus" module>
.list
  background-color #fff
  margin-bottom 20px
.searchBar
  zIndex(1)
.item
  display flex
  margin 0 16px
  padding 16px 0
  line-bottom-1px()
  cursor pointer

  &:last-child
    border-bottom none

  > img
    flex 0 0 auto
    display block
    width 130px
    max-height 71px
    object-fit cover
    margin-right 16px
    border-radius 4px

.desc
  flex 1

.name
  middle-font()
  ellipsis()
  margin-bottom 16px
</style>
